import ko from '@tko/build.knockout';
import template from 'raw-loader!./user-details-container-view.html';
import '../user-details-view';
import DataProvider from "../../../../app/data-framework/data-provider";

function UserDetailsContainerView(params) {

  var self = this;

  self.dataProvider = DataProvider.getInstance();
  self.route = params.route;
  self.view = self.route().view;

}

UserDetailsContainerView.prototype.dispose = function() {};

export default UserDetailsContainerView;

ko.components.register('historical2-user-details-container-view', { template, viewModel: UserDetailsContainerView });
